import {useState} from 'react';

type CadPreviewImageProps = {
    src: string;
};

/**
 * Renders the preview image IPTS supplies for a stock card, or nothing if it is missing.
 *
 * Some stock cards carry a PNG key for an object that was never uploaded, which the bucket
 * answers with a 403. Callers must key this by `src`: the failure belongs to one image, and
 * without a fresh instance per source the first miss suppresses every later preview.
 */
const CadPreviewImage = ({src}: CadPreviewImageProps): JSX.Element | null => {
    const [failed, setFailed] = useState(false);

    if (failed) {
        return null;
    }

    return (
        <img
            width="100%"
            src={src}
            alt="CAD file preview"
            onError={() => {
                setFailed(true);
            }}
        />
    );
};

export default CadPreviewImage;
